import { clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Merges class names, resolving Tailwind conflicts.
 *
 * `clsx` handles the conditionals; `twMerge` handles the part `clsx` cannot —
 * `cn('p-2', 'p-4')` is `p-4`, not both. Without it every component that takes
 * a `className` override would produce whichever of the two Tailwind emitted
 * later, which is not something a caller can reason about.
 */
export const cn = (...inputs) => twMerge(clsx(inputs));

export default cn;
